import { Grid } from '@mui/material';
import { NotificationScreen } from '@tassat/layout';
import React from 'react';

import authService from 'Lib/auth/AuthService';
import { useClientLogos } from 'SharedComponents/hooks/useClientLogos';
import { useClientThemeData } from 'SharedComponents/hooks/useClientThemeData';

import type { UnauthorizedFirmProps } from '.';

export const UnauthorizedFirm = (props: UnauthorizedFirmProps) => {
    const {
        classes,
        location
    } = props;

    const firmState = React.useMemo(() => location?.state?.firmState || '', [location]);
    const clientInfo = useClientThemeData();
    const clientLogoUrls = useClientLogos();

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
        >
            <NotificationScreen
                clientLogoUrl={clientLogoUrls.ApplicationLogoUrl}
                headerLogoHeight={65}
                logout={() => authService.logout()}
                messages={[
                    `Your firm has been ${firmState === 'IsClosed' ? 'closed' : 'locked'} by your administrator.` +
                    'Please contact Tassat Support for assistance.',
                    'Please contact us for assistance at any time, 24 hours a day, 7 days a week.'
                ]}
                subtitle='Your Gateway to the Future of Digital Financial Services'
                supportEmail={clientInfo.support.contactInfo.email || '#'}
                supportPhone={clientInfo.support.contactInfo.phoneDirect ||
                    clientInfo.support.contactInfo.phoneTollFree ||
                    'Call support line'}
                title={`Firm ${firmState === 'IsClosed' ? 'Closed' : 'Locked'}`}
                type='prop'
            />
        </Grid>
    );
};